import { Calendar, InternationalLocation, Restaurant } from '@maverick/entity';
import { BbiService, OloService } from '@maverick/cms';
import { LocationService } from '../services/Location.service';

type LocationInfo = Partial<{
	yextUrl: string;
}> | null;

export const LocationManager = {
	GetLocationInfo: async (yextId: string): Promise<LocationInfo> => {
		const response = await OloService.GetYextUrl(yextId);

		if (response.error) return null;

		return { yextUrl: response.body.yextUrl };
	},

	GetLocationCalendars: async (locationId: number): Promise<Calendar | null> => {
		const result = await OloService.GetLocationCalendar(locationId);
		if (result.error || !result.body.calendar?.length) return null;
		const businessCalendar = result.body.calendar.find((c: any) => c.type === 'business');
		if (!businessCalendar) return null;
		return Calendar.Make(businessCalendar);
	},

	GetTableWait: async (locationId: string): Promise<{ waitTime: string } | null> => {
		const result = await BbiService.GetTableWait(locationId);
		if (result.error) return null;

		return { waitTime: result.body };
	},

	ListCountries: async (): Promise<Array<string> | null> => {
		const result = await LocationService.ListCountries();
		if (result.error || !result.body?.length) {
			return null;
		}

		return result.body;
	},

	ListCountryLocations: async (country: string): Promise<Array<InternationalLocation> | null> => {
		const result = await LocationService.ListCountryLocation(country);
		if (result.error || !result.body?.length) {
			return null;
		}

		return result.body.map((i: any) => InternationalLocation.Make(i));
	},

	GetLocationByRef: async (ref: string): Promise<Restaurant | null> => {
		const result = await OloService.GetLocationByRef(ref);

		if (result.error || !result.body?.restaurants?.length) {
			return null;
		}

		return Restaurant.Make(result.body.restaurants[0]);
	},
};
